// extracted by mini-css-extract-plugin
module.exports = {"partnersListTitle":"FX2c0","partnersList":"_3S51I","partnersListInner":"_2q6oY","loadingWrapper":"_3JpYC"};